module.exports = __webpack_public_path__ + "static/media/opensea.419dfd0d.png";